import React from 'react';
import { Redirect } from 'react-router-dom';

class PodanNew extends React.Component {
  constructor(props) {
    super(props);
  }
  state = { redirect: '/applications' };
  render() {
    if (
      document.getElementsByClassName('sidebar') &&
      document.getElementsByClassName('sidebar')[0] &&
      document.getElementsByClassName('sidebar')[0].hidden !== true
    ) {
      document.getElementsByClassName('sidebar')[0].hidden = true;
    }
    if (!this.props.currentOrganisation) {
      return <Redirect to={this.state.redirect} />;
    }
    console.log(this.props);
    return (
      <>
        <div
          style={{
            width: '287mm',
            fontFamily: 'Time-New-Romans',
            margin: '50px auto 0',
          }}
        >
          <table
            cellspacing="0"
            cellpadding="5px"
            width="100%"
            height="100%"
            style={{
              pageBreakAfter: 'always',
              cellpadding: '5px',
              border: '1px solid',
              margin: '5px',
              transform: 'scale(90%)',
              marginTop: '-70px',
            }}
          >
            <tbody>
              <tr style={{ border: 'none' }}>
                <td
                  style={{ verticalAlign: 'baseline', border: '1px solid black' }}
                  width="50%"
                  valign="top"
                >
                  <div align="center">
                    <strong style={{ fontWeight: 'bold' }}>
                      ПАМ'ЯТКА
                      <br />
                      щодо заповнення форми подання на присвоєння спортивного звання
                    </strong>
                  </div>
                  <br />
                  <div align="justify" style={{ textIndent: '20px' }}>
                    У графі «вид спорту» вказується повна назва виду спорту, що включений до Реєстру
                    визнаних видів спорту в Україні, відповідно до Порядку визнання видів спорту,
                    включення їх до Реєстру визнаних видів спорту в Україні, порядок його ведення,
                    затвердженого наказом Міністерства молоді та спорту України від 27 січня 2014
                    року № 149, зареєстрованого в Міністерстві юстиції України 12 лютого 2014 року №
                    281/25058.
                  </div>
                  <div align="justify" style={{ textIndent: '20px' }}>
                    Графи «прізвище, власне ім'я, по батькові (за наявності)» - заповнюються
                    повністю.
                  </div>
                  <div align="justify" style={{ textIndent: '20px' }}>
                    Графа «дата народження» - заповнюється цифрами.
                  </div>
                  <div align="justify" style={{ textIndent: '20px' }}>
                    (Зазначені графи повинні відповідати даним паспорта).
                  </div>
                  <div align="justify" style={{ textIndent: '20px' }}>
                    У графі «фізкультурно-спортивне товариство, інший суб’єкт сфери фізичної
                    культури і спорту» - необхідно вказати належність до одного з них: «Динамо»,
                    «Колос», «Спартак», «Україна», Міністерство оборони України, Міністерство освіти
                    і науки України, Український центр з фізичної культури і спорту осіб з
                    інвалідністю «Інваспорт».
                  </div>
                  <div align="justify" style={{ textIndent: '20px' }}>
                    У графі «освіта» - зазначається наявність відповідного напряму та ступеня
                    освіти.
                  </div>
                  <div align="justify" style={{ textIndent: '20px' }}>
                    У графі «місце роботи (навчання), посада» - вказується найменування організації,
                    місце проходження військової служби, посада.
                  </div>
                  <div align="justify" style={{ textIndent: '20px' }}>
                    У графі «стаж тренерської роботи» - вказується дата початку та закінчення
                    тренерської роботи або вказується «до цього часу». Наприклад: з 1983 по 1991,
                    або з 1981 до цього часу.
                  </div>
                  <div align="justify" style={{ textIndent: '20px' }}>
                    У графі «основні показники» - зазначається: результат відповідно до Положення
                    про Єдину спортивну класифікацію України, затвердженого наказом Міністерства
                    молоді та спорту України від 11 жовтня 2013 року № 582, зареєстрованого в
                    Міністерстві юстиції України 04 листопада 2013 року № 1861/24393 або
                    кваліфікаційних норм та вимог до відповідного виду спорту, затверджених в
                    установленому законодавством порядку; дата його виконання; назва спортивних
                    змагань, що включені до відповідних календарних планів спортивних змагань.
                  </div>
                </td>
                <td style={{ verticalAlign: 'baseline', border: '1px solid black' }} width="50%">
                  <table
                    width="100% "
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                    style={{ pageBreakAfter: 'always', lineHeight: '0.95' }}
                  >
                    <tbody>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td style={{ verticalAlign: 'baseline' }} align="center">
                          <br />
                          <svg
                            width="11.5%"
                            viewBox="0 0 330 460"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0 0V347.556C0.0258 371.055 13.7602 393.485 36.8188 403.618L165 460L293.181 403.618C316.24 393.485 329.974 371.055 330 347.556V0H0Z"
                              fill="#004BC1"
                            />
                            <path
                              d="M5 5V345C5.0252 367.989 18.3432 389.931 40.7031 399.844L165 455L289.297 399.844C311.657 389.931 324.975 367.989 325 345V5H5V5Z"
                              fill="white"
                            />
                            <path
                              d="M165 30C155.68 40.5766 150 54.4213 150 69.6172C150.552 102.983 154.645 136.281 155 169.637C155.74 200.724 146.416 229.921 135.078 258.404C131.3 266.275 127.214 273.979 123.125 281.69L111.094 279.267C100.268 277.103 93.2262 266.575 95.3906 255.747C97.2845 246.273 105.622 239.694 114.922 239.65L119.297 240.119L109.531 158.541C106.339 122.213 87.6012 90.3488 60 69.6172C55.2568 66.0545 50.2312 62.7974 45 59.9278V349.672H111.875C116.875 376.822 131.814 400.474 152.812 416.716C157.807 420.159 161.991 424.7 165 430C168.009 424.7 172.193 420.159 177.188 416.716C198.186 400.474 213.125 376.822 218.125 349.672H285V59.9278C279.769 62.7974 274.743 66.0545 270 69.6172C242.399 90.3488 223.661 122.213 220.469 158.541L210.703 240.119L215.078 239.65C224.378 239.694 232.716 246.273 234.609 255.747C236.774 266.575 229.732 277.103 218.906 279.267L206.875 281.69C202.786 273.979 198.7 266.275 194.922 258.404C183.584 229.921 174.26 200.724 175 169.637C175.355 136.281 179.448 102.983 180 69.6172C180 54.4213 174.32 40.5766 165 30ZM65 101.655C77.9427 116.847 86.6288 135.78 89.2188 156.587L97.2656 223.866C87.0192 228.968 79.2515 238.328 76.3281 249.652H65V101.655ZM265 101.655V249.652H253.672C250.749 238.328 242.981 228.968 232.734 223.866L240.781 156.587C243.371 135.78 252.057 116.847 265 101.655ZM165 236.915C170.372 254.491 177.764 271.179 186.953 286.691C178.213 289.347 170.606 294.512 165 301.459C159.394 294.512 151.787 289.347 143.047 286.691C152.236 271.179 159.628 254.491 165 236.915ZM65 269.656H76.3281C79.8998 283.461 90.6757 294.369 104.375 298.177L113.984 300.365C111.411 309.695 110 319.524 110 329.668H65V269.656ZM253.672 269.656H265V329.668H220C220 319.524 218.589 309.695 216.016 300.365L225.625 298.177C239.324 294.369 250.1 283.461 253.672 269.656ZM133.516 304.976C145.648 306.691 155 317.062 155 329.668H130C130 321.093 131.27 312.829 133.516 304.976ZM196.484 304.976C198.73 312.829 200 321.093 200 329.668H175C175 317.062 184.352 306.691 196.484 304.976V304.976ZM132.266 349.672H155V391.789C143.967 380.253 135.952 365.767 132.266 349.672ZM175 349.672H197.734C194.048 365.767 186.033 380.253 175 391.789V349.672V349.672Z"
                              fill="#004BC1"
                            />
                          </svg>
                          <br />
                          <br />
                          <strong style={{ fontWeight: 'bold' }}>
                            МІНІСТЕРСТВО МОЛОДІ ТА СПОРТУ УКРАЇНИ
                            <br />
                            <br />П О Д А Н Н Я
                          </strong>
                          <br />
                          <br />
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td style={{ verticalAlign: 'baseline' }} align="center">
                          <div
                            style={{
                              display: 'inline-block',
                              borderBottom: '1px solid black',
                              width: '82%',
                              fontSize: '18px',
                            }}
                          >
                            {this.props.currentApplication.regionSport.name}
                          </div>
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td
                          style={{ verticalAlign: 'baseline', padding: '0' }}
                          align="center"
                          valign="top"
                        >
                          <i>
                            (найменування закладу (установи, організації) фізичної культури і
                            спорту)
                          </i>
                          <br />
                          <br />
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td style={{ verticalAlign: 'baseline', padding: '0' }} align="center">
                          порушує клопотання щодо присвоєння спортивного звання
                          <br />
                          <br />
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td style={{ verticalAlign: 'baseline' }} align="center">
                          <div
                            style={{
                              display: 'inline-block',
                              borderBottom: '1px solid black',
                              width: '88%',
                              fontSize: '18px',
                            }}
                          >
                            {this.props.currentApplication.athleteCategoryTitle.split('/')[0]}
                          </div>
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td
                          style={{ verticalAlign: 'baseline', padding: '0' }}
                          align="center"
                          valign="top"
                        >
                          (спортивне звання)
                          <br />
                          <br />
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td style={{ verticalAlign: 'baseline' }} align="center">
                          <div
                            style={{
                              display: 'inline-block',
                              borderBottom: '1px solid black',
                              width: '65%',
                              fontSize: '18px',
                            }}
                          >
                            {this.props.currentApplication.athleteLastName}
                          </div>
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td
                          style={{ verticalAlign: 'baseline', padding: '0' }}
                          align="center"
                          valign="top"
                        >
                          (прізвище)
                          <br />
                          <br />
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td style={{ verticalAlign: 'baseline' }} align="center">
                          <div
                            style={{
                              display: 'inline-block',
                              borderBottom: '1px solid black',
                              width: '65%',
                              fontSize: '18px',
                            }}
                          >
                            {this.props.currentApplication.athleteFirstName}{' '}
                            {this.props.currentApplication.athleteSecondName}
                          </div>
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td
                          style={{ verticalAlign: 'baseline', padding: '0' }}
                          align="center"
                          valign="top"
                        >
                          (власне ім'я, по батькові (за наявності))
                          <br />
                          <br />
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto', fontSize: '12px' }}>
                        <td style={{ verticalAlign: 'baseline' }} align="center">
                          <br />
                          <table width="100%" border="1" cellspacing="0" cellpadding="4px">
                            <tbody>
                              <tr style={{ border: 'none', height: 'auto' }}>
                                <td
                                  style={{
                                    verticalAlign: 'baseline',
                                    border: '1px solid black',
                                    borderBottom: 'none',
                                    padding: '2px',
                                  }}
                                  width="50%"
                                  align="center"
                                  valign="top"
                                >
                                  <div
                                    style={{
                                      display: 'inline-block',
                                      borderBottom: '1px solid black',
                                      width: '81%',
                                      fontSize: '14px',
                                    }}
                                  >
                                    {this.props.currentApplication.organisation.name}
                                  </div>
                                  <br />
                                  <br />
                                  <i>
                                    (найменування первинної фізкультурно-спортивної організації,
                                    іншого суб'єкта сфери фізичної культури і спорту)
                                  </i>
                                </td>
                                <td
                                  style={{
                                    verticalAlign: 'baseline',
                                    border: '1px solid black',
                                    borderBottom: 'none',
                                    padding: '2px',
                                  }}
                                  width="50%"
                                  align="center"
                                  valign="top"
                                >
                                  <div
                                    style={{
                                      display: 'inline-block',
                                      borderBottom: '1px solid black',
                                      width: '81%',
                                      fontSize: '14px',
                                    }}
                                  >
                                    {this.props.currentApplication.regionSport.name}
                                  </div>
                                  <br />

                                  <i>
                                    (найменування закладу (установи, організації) що порушує
                                    клопотання щодо присвоєння спортивного звання)
                                  </i>
                                </td>
                              </tr>
                              <tr style={{ border: 'none', height: 'auto' }}>
                                <td
                                  style={{
                                    verticalAlign: 'baseline',
                                    border: '1px solid black',
                                    borderBottom: 'none',
                                    borderTop: 'none',
                                    padding: '2px',
                                  }}
                                  width="50%"
                                  align="center"
                                  valign="top"
                                >
                                  <table width="100%" cellspacing="0" cellpadding="0" border="0">
                                    <tbody>
                                      <tr style={{ border: 'none', height: 'auto' }}>
                                        <td style={{ verticalAlign: 'baseline', padding: '0' }}>
                                          Керівник&nbsp;
                                        </td>
                                        <td style={{ verticalAlign: 'baseline', padding: '0' }}>
                                          <div
                                            style={{
                                              display: 'inline-block',
                                              borderBottom: '1px solid black',
                                              width: '100%',
                                              textAlign: 'right',
                                              fontSize: '14px',
                                            }}
                                          >
                                            {this.props.currentApplication.organisation
                                              .headEmployee &&
                                              this.props.currentApplication.organisation
                                                .headEmployee.firstName}{' '}
                                            {this.props.currentApplication.organisation
                                              .headEmployee &&
                                              this.props.currentApplication.organisation.headEmployee.lastName.toUpperCase()}
                                          </div>
                                        </td>
                                      </tr>
                                      <tr style={{ border: 'none', height: 'auto' }}>
                                        <td style={{ verticalAlign: 'baseline', padding: '0' }}>
                                          &nbsp;
                                        </td>
                                        <td
                                          style={{ verticalAlign: 'baseline' }}
                                          align="center"
                                          valign="top"
                                        >
                                          підпис (Власне ім'я ПРІЗВИЩЕ)
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td
                                  style={{
                                    verticalAlign: 'baseline',
                                    border: '1px solid black',
                                    borderBottom: 'none',
                                    borderTop: 'none',
                                    padding: '2px',
                                  }}
                                  width="50%"
                                  align="center"
                                  valign="top"
                                >
                                  <table width="100%" cellspacing="0" cellpadding="0" border="0">
                                    <tbody>
                                      <tr style={{ border: 'none', height: 'auto' }}>
                                        <td style={{ verticalAlign: 'baseline', padding: '0' }}>
                                          Керівник&nbsp;
                                        </td>
                                        <td style={{ verticalAlign: 'baseline', padding: '0' }}>
                                          <div
                                            style={{
                                              display: 'inline-block',
                                              borderBottom: '1px solid black',
                                              width: '100%',
                                              fontSize: '14px',
                                              textAlign: 'right',
                                            }}
                                          >
                                            {this.props.currentApplication.regionSport
                                              .headEmployee &&
                                              this.props.currentApplication.regionSport.headEmployee
                                                .firstName}{' '}
                                            {this.props.currentApplication.regionSport
                                              .headEmployee &&
                                              this.props.currentApplication.regionSport.headEmployee.lastName.toUpperCase()}
                                          </div>
                                        </td>
                                      </tr>
                                      <tr style={{ border: 'none', height: 'auto' }}>
                                        <td style={{ verticalAlign: 'baseline', padding: '0' }}>
                                          &nbsp;
                                        </td>
                                        <td
                                          style={{ verticalAlign: 'baseline' }}
                                          align="center"
                                          valign="top"
                                        >
                                          підпис (Власне ім'я ПРІЗВИЩЕ)
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr style={{ border: 'none', height: 'auto' }}>
                                <td
                                  style={{
                                    verticalAlign: 'baseline',
                                    border: '1px solid black',
                                    borderTop: 'none',
                                    padding: '2px',
                                  }}
                                  width="50%"
                                  align="center"
                                  valign="top"
                                >
                                  <div align="left">
                                    Дата&nbsp;
                                    <div
                                      style={{
                                        display: 'inline-block',
                                        borderBottom: '1px solid black',
                                        width: ' 53%',
                                      }}
                                    >
                                      {}
                                    </div>
                                    М.П.
                                  </div>
                                </td>
                                <td
                                  style={{
                                    verticalAlign: 'baseline',
                                    border: '1px solid black',
                                    borderTop: 'none',
                                    padding: '2px',
                                  }}
                                  width="50%"
                                  align="center"
                                  valign="top"
                                >
                                  <div align="left">
                                    Дата&nbsp;{' '}
                                    <div
                                      style={{
                                        display: 'inline-block',
                                        borderBottom: '1px solid black',
                                        width: ' 53%',
                                      }}
                                    >
                                      {}
                                    </div>
                                    М.П.
                                  </div>
                                  <br />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr style={{ border: 'none', height: 'auto' }}>
                        <td style={{ verticalAlign: 'baseline', paddingTop: '3px' }}>
                          Дата надходження до Мінмолодьспорту&nbsp;
                          <div
                            style={{
                              display: 'inline-block',
                              borderBottom: '1px solid black',
                              width: '38%',
                            }}
                          >
                            {}
                          </div>
                          <br />
                          <br />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* <div style={{'width':'287mm', fontFamily:'Time-New-Romans','transform':'scale(100%)','margin':'50px auto 0'}}>
            <table cellspacing='0' cellpadding='5px' width='100%' height='100%' style={{pageBreakAfter:'always','cellpadding':'5px'}}>
                <tbody>
                    <tr style={{'border': 'none'}}>
                        <td style={{verticalAlign:'baseline'}}  width='50%' valign='top'>
                            <table width='100%' border='1' cellspacing='0' cellpadding='2px' style={{fontSize:'0.9rem',minHeight:'210mm', height:'210mm' ,maxHeight:'210mm'}}>
                                <tbody>
                                    <tr style={{'border': '1px solid black','height':'auto'}}>
                                        <td style={{'padding':'0 0 0 3px','border':'1px solid black'}} width='42%' colSpan='2' valign='middle'>
                                            Вид спорту
                                        </td>
                                        <td style={{'padding':'0 0 0 3px','border':'1px solid black',fontSize:'14px'}} width='34%'>
                                            {this.props.currentApplication.sportTitle}
                                        </td>
                                        <td style={{'border':'1px solid black','height':'40mm',"width":'30mm','border':'1px solid black'}} rowSpan='7' align='center'>
                                            {this.props.documents &&  this.props.documents.length>0 &&  this.props.documents.map(el=>{
                                                if(el.type===5){            
                                                    return(
                                                        <div style={{'backgroundImage':`url(${el.url})`,'height':'100%','width':'100%','backgroundSize': 'cover','backgroundRepeat':'no-repeat'}}>
                                                            {/* <img style={{'max-width':'95%','max-height':'95%','margin':'0 auto'}}  src={el.url} alt=""/> 
                                                        </div>
                                                        
                                                )}
                                        })}</td></tr>           
                                    <tr  style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2' valign='middle'>
                                            Прізвище
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>
                                            {this.props.currentApplication.athleteLastName}
                                        </td>
                                    </tr>
                                    <tr  style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2' valign='middle'>
                                            Власне ім'я
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>
                                            {this.props.currentApplication.athleteFirstName}
                                        </td>
                                    </tr>
                                    <tr  style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2' valign='middle'>
                                            По батькові (за наявності)
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>
                                            {this.props.currentApplication.athleteSecondName}
                                        </td>
                                    </tr>
                                    <tr  style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='3' align='center' valign='middle'>
                                            Дата народження
                                        </td>
                                    </tr>
                                    <tr  style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center'>
                                            число
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center'>
                                            місяць
                                        </td>
                                        <td style={{verticalAlign:'middle'}} align='center'>
                                            рік
                                        </td>
                                    </tr>
                                    <tr  style={{'border': 'none','height':'auto'}}>
                                        <td colSpan='3' style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center'>
                                            {new Date(this.props.currentApplication.birthday).toLocaleString('uk-UA',{day:'numeric', month:'numeric', year:'numeric'})}
                                        </td>
                                    </tr>
                                    {this.props.currentApplication.athleteCategoryTitle==='Заслужений тренер України/ЗТУ'
                                        && 
                                        <tr  style={{'border': 'none','height':'auto'}}>
                                            <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                                Стаж тренерської роботи
                                            </td>
                                            <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                                з&nbsp;
                                                <div style={{'display':'inline-block',borderBottom:'1px solid black'}}>
                                                    {new Date(this.props.currentApplication.athleteTrainerExperienceFrom).toLocaleString('uk-UA',{day:'numeric', month:'numeric', year:'numeric'})}
                                                </div>
                                                по&nbsp;
                                                <div style={{'display':'inline-block',borderBottom:'1px solid black'}}>
                                                    {new Date(this.props.currentApplication.athleteTrainerExperienceTo).toLocaleString('uk-UA',{day:'numeric', month:'numeric', year:'numeric'})}
                                                </div>
                                            </td>
                                        </tr>}
                                    <tr  style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            Місце проживання на час надання
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            {this.props.currentApplication.adress}
                                        </td>
                                    </tr>
                                    <tr  style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            Фізкультурно-спортивне товариство, інший суб'єкт сфери фізичної культури і спорту
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            {this.props.currentApplication.company}
                                            </td>
                                        </tr>
                                    <tr  style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            Освіта
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            {this.props.currentApplication.education}
                                        </td>
                                    </tr>
                                    <tr  style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            Місце роботи (навчання), посада
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            {this.props.currentApplication.workPlace}
                                        </td>
                                    </tr>
                                    <tr style={{'border': 'none','height':'auto'}} >
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            Попереднє звання та дата происвоєння
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            {this.props.currentApplication.previousSportCategoryTitle}
                                            {new Date(this.props.currentApplication.previousSportCategoryDate).toLocaleString('uk-UA',{day:'numeric', month:'numeric', year:'numeric'})}
                                        </td>
                                    </tr>
                                    <tr style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            Власне ім'я ПРІЗВИЩЕ тренера, що підготувал спортсмена
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>
                                            {this.props.currentApplication.trainerLastNameFirst}
                                            {this.props.currentApplication.trainerFirstNameFirst}
                                            {this.props.currentApplication.trainerSecondNameFirst}
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} valign='top'>
                                            Тренерська<br/>категорія: 
                                            <div style={{'display':'inline-block',borderBottom:'1px solid black'}}>
                                                {this.props.currentApplication.trainerCategoryFirst}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            Власне ім'я ПРІЗВИЩЕ тренера, що підготувал спортсмена
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>
                                            {this.props.currentApplication.trainerLastNameSecond} 
                                            {this.props.currentApplication.trainerFirstNameSecond} 
                                            {this.props.currentApplication.trainerSecondNameSecond}
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} valign='top'>
                                            Тренерська<br/>категорія: 
                                            <div style={{'display':'inline-block',borderBottom:'1px solid black'}}>
                                                {this.props.currentApplication.trainerCategorySecond}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='2'>
                                            Власне ім'я ПРІЗВИЩЕ тренера, що підготувал спортсмена
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>
                                            {this.props.currentApplication.trainerLastNameThird} {this.props.currentApplication.trainerFirstNameThird} {this.props.currentApplication.trainerSecondNameThird}
                                        </td>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} valign='top'>
                                            Тренерська<br/>категорія: 
                                            <div style={{'display':'inline-block',borderBottom:'1px solid black'}}>
                                                {this.props.currentApplication.trainerCategoryThird}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr style={{'border': 'none','height':'auto'}}>
                                        <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='4'>
                                            <table width='100%' cellspacing='0' cellpadding='0' border='0' style={{fontSize:'0.9rem'}}>
                                                <tbody>
                                                    <tr  style={{'border': 'none','height':'auto'}}>
                                                        <td style={{verticalAlign:'middle'}} colSpan='5' align='center'>
                                                            <strong style={{fontWeight:'bold'}}>
                                                                ВИСНОВОК
                                                            </strong>
                                                        </td>
                                                    </tr>
                                        <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle'}} colSpan='5'>структурного підрозділу Мінмолодьспорту, до повноважень якого віднесено координацію розвитку виду спорту: матеріали відповідають / не відповідають вимогам</td></tr>
                                        <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle'}} width='41%'>Відповідальний виконавець з виду спорту Мінмолодьспорту</td><td style={{verticalAlign:'middle',borderBottom:'1px solid black'}}width='18%'>&nbsp;</td><td style={{verticalAlign:'middle'}}>&nbsp;</td><td style={{verticalAlign:'middle',borderBottom:'1px solid black'}} width='31%' valign='bottom'>{}</td><td style={{verticalAlign:'middle'}}>&nbsp;</td></tr>
                                        <tr style={{'border': 'none','height':'auto',marginBottom:'0.5rem','border':'none','padding':'0','height':'auto'}}><td style={{verticalAlign:'middle'}}>&nbsp;</td><td style={{verticalAlign:'middle'}} align='center' valign='top'>(підпис)</td><td style={{verticalAlign:'middle'}}>&nbsp;</td><td style={{verticalAlign:'middle'}} align='center' valign='top'>(Власне&nbsp;ім'я&nbsp;ПРІЗВИЩЕ)</td><td style={{verticalAlign:'middle'}}>&nbsp;</td></tr>
                                        <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle'}}>Керівник структурного підрозділу Мінмолодьспорту, до повноважень якого віднесено координацію розвитку виду спорту</td><td style={{verticalAlign:'middle', borderBottom:'1px solid black'}}>&nbsp;</td><td style={{verticalAlign:'middle'}}>&nbsp;</td><td style={{verticalAlign:'middle',borderBottom:'1px solid black'}} valign='bottom'>{}</td><td style={{'verticalAlign':'baseline'}}>&nbsp;</td></tr>
                                        <tr style={{'border': 'none','height':'auto', marginBottom:'0.5rem','border':'none','padding':'0','height':'auto'}}><td style={{verticalAlign:'middle'}}>&nbsp;</td><td style={{verticalAlign:'middle'}} align='center' valign='top'>(підпис)</td><td style={{verticalAlign:'middle'}}>&nbsp;</td><td style={{verticalAlign:'middle'}} align='center' valign='top'>(Власне&nbsp;ім'я&nbsp;ПРІЗВИЩЕ)</td><td style={{verticalAlign:'middle'}}>&nbsp;</td></tr>
                                        <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle', paddingLeft:'1rem',borderBottom:'1px solid black'}}>&nbsp;</td><td style={{verticalAlign:'middle'}} colSpan='4'>&nbsp;</td></tr>
                                        <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle'}} align='center' valign='top'>(дата)</td><td style={{verticalAlign:'middle'}} colSpan='4'>&nbsp;</td></tr>
                                        </tbody>
                                        </table><br/>
                                    </td></tr>
                                </tbody>
                            </table>
                        </td>
                        <td style={{minHeight:'210mm',maxHeight:'210mm',verticalAlign:'top' }} width='50%' >
                            <table width='100%' border='1' cellspacing='0' cellpadding='2px' style={{fontSize:'0.9rem',minHeight:'210mm', height:'210mm' ,maxHeight:'210mm'}}>
                            <tbody>
                            <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='4' align='center'>ОСНОВНІ ПОКАЗНИКИ</td></tr>
                            <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle' ,'padding':'0','border':'1px solid black'}} width='25%' align='center' valign='middle'>Дата виконання, число, місяць, рік</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='27%' align='center' valign='middle'>Назва змагань</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='15%' align='center' valign='middle'>Ранг, категорія змагань</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center' valign='middle'>Виконаний результат</td></tr>
                            {this.props.currentApplication.achievements && this.props.currentApplication.achievements.length>0 && this.props.currentApplication.achievements.map(el=>{
                            return(
                                <tr style={{'border': 'none','height':'30px'}}>
                                    <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{el.eventDateStart && new Date(el.eventDateStart).toLocaleString('uk-UA',{day:'numeric', month:'numeric', year:'numeric'})}  {el.eventDateEnd && new Date(el.eventDateEnd).toLocaleString('uk-UA',{day:'numeric', month:'numeric', year:'numeric'})} </td>
                                    <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{el.eventTitle}</td>
                                    <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{
                                    this.props.fullList&&  this.props.fullList[6]  && this.props.fullList[6].map(elem=>{
                                        if(elem.id===el.eventCategory)
                                            return(
                                                <>{elem.title}</>
                                        )
                                        })}
                                    </td>
                                    <td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{el.eventResult}</td>
                                </tr>
                            )

                            })}
                            {this.props.currentApplication.achievements.length<10 && <tr style={{'border': 'none','height':'30px'}}><td style={{verticalAlign:'middle' ,'padding':'0','border':'1px solid black'}} width='25%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='27%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='15%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center' valign='middle'> </td></tr>}
                            {this.props.currentApplication.achievements.length<9 &&<tr style={{'border': 'none','height':'30px'}}><td style={{verticalAlign:'middle' ,'padding':'0','border':'1px solid black'}} width='25%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='27%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='15%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center' valign='middle'> </td></tr>}
                            {this.props.currentApplication.achievements.length<8 &&<tr style={{'border': 'none','height':'30px'}}><td style={{verticalAlign:'middle' ,'padding':'0','border':'1px solid black'}} width='25%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='27%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='15%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center' valign='middle'> </td></tr>}
                            {this.props.currentApplication.achievements.length<7 &&<tr style={{'border': 'none','height':'30px'}}><td style={{verticalAlign:'middle' ,'padding':'0','border':'1px solid black'}} width='25%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='27%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='15%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center' valign='middle'> </td></tr>}
                            {this.props.currentApplication.achievements.length<6 &&<tr style={{'border': 'none','height':'30px'}}><td style={{verticalAlign:'middle' ,'padding':'0','border':'1px solid black'}} width='25%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='27%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='15%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center' valign='middle'> </td></tr>}
                            {this.props.currentApplication.achievements.length<5 &&<tr style={{'border': 'none','height':'30px'}}><td style={{verticalAlign:'middle' ,'padding':'0','border':'1px solid black'}} width='25%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='27%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='15%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center' valign='middle'> </td></tr>}
                            {this.props.currentApplication.achievements.length<4 &&<tr style={{'border': 'none','height':'30px'}}><td style={{verticalAlign:'middle' ,'padding':'0','border':'1px solid black'}} width='25%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='27%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='15%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center' valign='middle'> </td></tr>}
                            {this.props.currentApplication.achievements.length<3&&<tr style={{'border': 'none','height':'30px'}}><td style={{verticalAlign:'middle' ,'padding':'0','border':'1px solid black'}} width='25%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='27%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='15%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center' valign='middle'> </td></tr>}
                            {this.props.currentApplication.achievements.length<2 &&<tr style={{'border': 'none','height':'30px'}}><td style={{verticalAlign:'middle' ,'padding':'0','border':'1px solid black'}} width='25%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='27%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} width='15%' align='center' valign='middle'></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center' valign='middle'> </td></tr>}

                            <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center'>Суддівська колегія</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center'>Власне ім'я<br/>ПРІЗВИЩЕ</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center'>Місто,<br/>країна</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} align='center'>Суддівська категорія</td></tr>
                            <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>Головний суддя</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{this.props.currentApplication.eventMainJudgeLastName} {this.props.currentApplication.eventMainJudgeFirstName} {this.props.currentApplication.eventMainJudgeSecondName}</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{this.props.currentApplication.eventMainJudgeCity}</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{this.props.fullList&&  this.props.fullList[5]  && this.props.fullList[5].map((elem)=>{
                                                        if(elem.id===this.props.currentApplication.eventMainJudgeCategory)
                                                            return(
                                                                <>{elem.title}</>
                                                        )
                                                        })}</td></tr>
                            <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>Заступник головного судді</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{this.props.currentApplication.eventViceMainJudgeLastName} {this.props.currentApplication.eventViceMainJudgeFirstName} {this.props.currentApplication.eventViceMainJudgeSecondName}</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{this.props.currentApplication.eventViceMainJudgeCity}</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{this.props.fullList&&  this.props.fullList[5]  && this.props.fullList[5].map((elem)=>{
                                                        if(elem.id===this.props.currentApplication.eventViceMainJudgeCategory)
                                                            return(
                                                                <>{elem.title}</>
                                                        )
                                                        })}</td></tr>
                            <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>Суддя</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{this.props.currentApplication.eventJudgeLastName} {this.props.currentApplication.eventJudgeFirstName} {this.props.currentApplication.eventJudgeSecondName}</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{this.props.currentApplication.eventJudgeCity}</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{this.props.fullList&&  this.props.fullList[5]  && this.props.fullList[5].map((elem)=>{
                                                        if(elem.id===this.props.currentApplication.eventJudgeCategory)
                                                            return(
                                                                <>{elem.title}</>
                                                        )
                                                        })}</td></tr>
                            <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{}</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{}</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{' '}&nbsp;{ }</td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{}</td></tr>
                            <tr style={{'border': 'none','height':'auto'}}><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}} colSpan='3'>Дата надходження до структурного підрозділу Мінмолодьспорту, до повноважень якого відносяться питання присвоєння спортивних звань&nbsp;<div style={{'display':'inline-block',borderBottom:'1px solid black' ,'width':'40%',marginBottom:'0.5rem'}}>&nbsp;</div></td><td style={{verticalAlign:'middle','padding':'0 0 0 3px','border':'1px solid black'}}>{}</td></tr>
                            </tbody>
                            </table><br/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div> */}
      </>
    );
  }
}

export default PodanNew;
